import moment from 'moment';
import { storage } from 'BASE/common/util/util.storage';
import download_component from '#BASE/components/downLoad/DownLoadCenter';

export default {
    name: 'LoginEntry',
    data: function () {
        return {
            isLock: true, // 關閉按鈕
            lockTime: '', // 關閉按鈕倒數
            InitLockTime: 5, // 預設倒數時間
            isShow: false, // 面板顯示
            PCUrl: '', // PC下載地址
            AndroidUrl: '', // Android下載地址
            timerID: null, // 計時器ID
            checkSettingComplete: false, // 是否確認後台有設定完整才開啟頁面
            btnStyleConf: {
                // 按鈕樣式 true為lock狀態
                [true]: 'btns leave_btn',
                [false]: 'btns main_btn',
            },
            isNotShowToday: true,
            QrcodeOptions: {
                width: 80,
                margin: 1,
            },
            ShowLoginEntryBlock: false,
        };
    },
    mixins: [download_component],
    methods: {
        // 覆寫DownLoadCenter的Init
        async Init() {},
        Hide() {
            if (this.isNotShowToday) {
                let today = moment(new Date()).format('YYYY/MM/DD');
                storage.local.set(storage.keys.LOGIN_ENTRY, today);
            }

            storage.local.set(storage.keys.LOGIN_ENTRY_POP, true);
            this.isShow = false;
        },
        async Show() {
            let _this = this;
            if (!this.IsSettingComplete) await _this.GetLoginEntryConfig();

            if (_this.InitLockTime !== 0) {
                _this.isLock = true;
                _this.lockTime = _this.InitLockTime;
                _this.timerID = setInterval(_this.Update, 1000);
            } else {
                _this.isLock = false;
            }

            _this.isShow = true;
        },
        OpenWindow(url) {
            window.open(url, '_blank');
        },
        iOSDownload() {
            this.$dialog.warning('敬请期待');
        },
        async GetLoginEntryConfig() {
            let _this = this;
            let result = await $.post('/api/LoginEntry/GetLoginEntrySetting');
            if (result) {
                _this.PCUrl = '';
                if (result.LoginEntryPCUrl) {
                    _this.PCUrl = result.LoginEntryPCUrl;
                } else if (result.LoginEntryPCFile) {
                    _this.PCUrl = _this.FileName(result.LoginEntryPCFile);
                }
                _this.AndroidUrl = '';
                if (result.LoginEntryAndroidUrl) {
                    _this.AndroidUrl = result.LoginEntryAndroidUrl;
                } else if (result.LoginEntryAndroidFile) {
                    _this.AndroidUrl = _this.FileName(result.LoginEntryAndroidFile);
                }

                _this.ShowLoginEntryBlock = _this.PCUrl != '' || _this.AndroidUrl != '';
            }
        },
        // 按鈕倒數
        Update() {
            let _this = this;
            if (--_this.lockTime == 0) {
                _this.isLock = false;
                if (_this.timerID != null) {
                    clearInterval(_this.timerID);
                }
            }
        },
        //每日首登
        async CheckDailyDisplay() {
            if (this.checkSettingComplete) {
                await this.GetLoginEntryConfig();
                if (!this.IsSettingComplete) {
                    return;
                }
            }

            let _loginPop = storage.local.get(storage.keys.LOGIN_ENTRY_POP);
            if (_loginPop) return;

            let today = moment(new Date()).format('YYYY/MM/DD');
            let displayDate = storage.local.get(storage.keys.LOGIN_ENTRY);
            if (today != displayDate) {
                this.Show();
            }
        },
        ChangeNotShowToday() {
            this.isNotShowToday = !this.isNotShowToday;
        },
    },
    computed: {
        btnStyle() {
            return this.btnStyleConf[this.isLock];
        },
        lockStr() {
            if (this.lockTime <= 0) return '';
            else return '( ' + this.lockTime + ' )';
        },
        IsSettingComplete() {
            return this.PCUrl != '' || this.AndroidUrl != '';
        },
    },
    watch: {
        IsSettingComplete(value) {
            this.$emit('setting_complete', value);
        },
    },
    mounted() {
        this.CheckDailyDisplay();
    },
};
